export enum CookiesNames {
  _CUSTOMER_TYPE = 'customerType',
  _SELECTED_STORE_ID = 'selectedStoreId',
  _TERMS_ACCEPTED = 'termsAccepted',
}
